import { motion } from "framer-motion";
import WhatsappSvg from "../../../assets/whatsapp.svg";
import { useTranslation } from "react-i18next";
import { sendWhatsappMessage } from "../../../../../utils"
import appConfig from "../../../../../utils/config/appConfig.json"


export default function WhatsappButton() {
	const { t } = useTranslation();
	const message = t("navBarItems.floatingActionShortcuts.whatsapp.defaultMessage");
  	const phone = appConfig.company.whatsappNumber;

	return (
		<section
			className={`
                flex flex-col justify-center items-center 
                w-[40px] xl:w-[70px] 2xl:w-[5vw] aspect-square hover:scale-110 active:scale-90 active:duration-150
                cursor-pointer transition-all duration-500 min-w-12 p-1
            `}
		>	
			<motion.button
				aria-label={t("navBarItems.floatingActionShortcuts.whatsapp.title")}
				title={t("navBarItems.floatingActionShortcuts.whatsapp.title")}
				onClick={() => sendWhatsappMessage(phone, message)}
				className="transition-colors duration-500 rounded-full w-full h-full flex items-center justify-center cursor-pointer"
				type="button"
				initial={{ scale: 0 }}
				animate={{ scale: 1 }}
				transition={{
					type: "spring",
					stiffness: 500,
					damping: 20,
					bounce: 0.6,
					delay: 3,
				}}
            	whileTap={{ scale: 0.9 }}
			>
				<img
					className="w-full aspect-square [filter:drop-shadow(0_0_3px_rgba(0,0,0,0.2))] xl:[filter:drop-shadow(0_0_6px_rgba(0,0,0,0.4))] 2xl:[filter:drop-shadow(0_0_0.35vw_rgba(0,0,0,0.4))] "
					src={WhatsappSvg}
					alt=""
					role="presentation"
					loading="eager"
					width={100}
					height={100}
				/>
			</motion.button>
		</section>
	);
}
